import React, { useState, useEffect, useRef, useCallback } from "react";
import { ReactComponent as TruckSVG } from "./TruckSVG.svg";
import { ReactComponent as TruckCargoSVG } from "./TruckCargoSVG.svg";
// import { Form } from "react-bootstrap";
import "./YardViewInside.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import useApp from "../AppContext";
import { callApi, ErrorAlert } from "../crud/utils";
import { loadListAllObjects, loadDataObject } from "./../Calendar/CalendarUtils";
import { format, subMonths } from 'date-fns';
import InboxIcon from '@mui/icons-material/Inbox';
import Loading from './../Loading';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import DroppableRamp from "./DroppableRamp";
import DraggableTruck from "./DraggableTruck";
import { DndContext } from '@dnd-kit/core';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import RefreshIcon from '@mui/icons-material/Refresh';
import WarningIcon from '@mui/icons-material/Warning';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useWebSocket } from "../WebSocketContext";
import { t } from "./../i18n";
import { Box, Typography, Divider } from '@mui/material';
import ConnectionLines from './components/ConnectionLines';
import TruckToggleButton from "./components/TruckToggleButton";
import WarehouseFilter from "./components/WarehouseFilter";
import ZoneFilter from "./components/ZoneFilter";
import RampContextMenu from "./components/RampContextMenu";
import { getTruckDisplayText as getTruckDisplayTextHelper, calculateRampsPerRow as calcRampsPerRow } from "./yardHelpers";

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: '#fff',
        color: '#000',
        boxShadow: '0px 3px 10px rgba(0, 0, 0, 0.2)',
        borderRadius: 12,
        padding: '12px 16px',
        width: 280,
        fontSize: 14,
    },
    [`& .MuiTooltip-arrow`]: {
        color: '#fff',
    },
}));

const TruckJourneyLayout = (props) => {
    const [selectedBookingDetails, setSelectedBookingDetails] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0, isHalfSlot: false });
    const [tooltipKey, setTooltipKey] = useState(0);
    const app = useApp();
    const [serverUrl] = useState(app.serverUrl);
    const [allColumnsObj, setAllColumnsObj] = useState({});
    const [defaultwarehouseId, setDefaultwarehouseId] = useState(null);
    const [selectedWarehouseId, setSelectedWarehouseId] = useState(null);
    const [data, setData] = useState({});
    const [language] = useState(app.sessionToken?.Language);
    const [userid] = useState(app.sessionToken?.UserId);
    const [selectedZoneId, setSelectedZoneId] = useState(null);
    const [showAllZones, setShowAllZones] = useState(false);
    const [hoveredTruckIndex, setHoveredTruckIndex] = useState(null);
    const [hasTimePassedMap, setHasTimePassedMap] = useState({});
    const [zonesByWarehouse, setZonesByWarehouse] = useState([]);
    const [yardPositions, setYardPositions] = useState([]);
    const [error, setError] = useState(null);
    const [rampsLoaded, setRampsLoaded] = useState(false);
    const [loadingRamps, setLoadingRamps] = useState(false);
    const [yardBookings, setYardBookings] = useState([]);
    const [selectedBookingId, setSelectedBookingId] = useState(null);
    const [selectedBookingIdArrival, setSelectedBookingIdArrival] = useState(null);


    const [clickedTasks, setClickedTasks] = useState([]);
    const clickedTasksRef = useRef(clickedTasks);
    const [refreshing, setRefreshing] = useState(false);
    const [contextMenu, setContextMenu] = useState(null);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isDraggingOverRampRow2, setIsDraggingOverRampRow2] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [, forceUpdate] = useState(0);
    const [showSupplier, setShowSupplier] = useState(true);
    const ws = useWebSocket();
    const timeoutRefs = useRef({});

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleRampScroll = () => {
            forceUpdate(prev => prev + 1);
        };

        const rampRows = document.querySelectorAll('.ramp-row, .ramp-row2');
        rampRows.forEach(row => {
            row.addEventListener('scroll', handleRampScroll);
        });

        return () => {
            rampRows.forEach(row => {
                row.removeEventListener('scroll', handleRampScroll);
            });
        };
    }, [yardPositions]);

    useEffect(() => {
        const sidebar = document.getElementById('sidebar');
        if (!sidebar) return;

        const handleSidebarChange = () => {
            forceUpdate(prev => prev + 1);
        };
        sidebar.addEventListener('mouseenter', handleSidebarChange);
        sidebar.addEventListener('mouseleave', handleSidebarChange);
        const handleTransitionEnd = (e) => {
            if (e.propertyName === 'width') {
                forceUpdate(prev => prev + 1);
            }
        };
        sidebar.addEventListener('transitionend', handleTransitionEnd);

        return () => {
            sidebar.removeEventListener('mouseenter', handleSidebarChange);
            sidebar.removeEventListener('mouseleave', handleSidebarChange);
            sidebar.removeEventListener('transitionend', handleTransitionEnd);
        };
    }, []);

    useEffect(() => {
        clickedTasksRef.current = clickedTasks;
        if (selectedBookingId) {
            setTooltipKey(prev => prev + 1);
        }
    }, [clickedTasks, selectedBookingId]);


    /* Αυτοματη επιλογή tasks χωρις καποιο κλικ */
    useEffect(() => {
        if (yardBookings.length === 0) return;

        setClickedTasks(prev => {
            const autoSelectableTasks = [];

            yardBookings.forEach(booking => {
                if (booking.BOOKINGTASKS && booking.BOOKINGTASKS.length === 1) {
                    const taskId = booking.BOOKINGTASKS[0].BOOKINGTASKID;
                    if (!prev.find(t => t.bookingTaskId === taskId)) {
                        autoSelectableTasks.push({ bookingTaskId: taskId });
                    }
                } else if (booking.TRUCKTYPE === 2 && booking.BOOKINGTASKS) {
                    booking.BOOKINGTASKS.forEach(task => {
                        if (!prev.find(t => t.bookingTaskId === task.BOOKINGTASKID)) {
                            autoSelectableTasks.push({ bookingTaskId: task.BOOKINGTASKID });
                        }
                    });
                }
            });

            if (autoSelectableTasks.length > 0) {
                return [...prev, ...autoSelectableTasks];
            }
            return prev;
        });
    }, [yardBookings]);

    const calculateRampsPerRow = useCallback(() => {
        return calcRampsPerRow(windowWidth);
    }, [windowWidth]);

    const handleTaskClick = (taskId) => {
        setClickedTasks(prevTasks => {
            const exists = prevTasks.find(t => t.bookingTaskId === taskId);

            if (exists) {
                return [];
            } else {
                return [{ bookingTaskId: taskId }];
            }
        });
    };

    const handleContextMenu = (event, ramp) => {
        event.preventDefault();
        setContextMenu({
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
            ramp: ramp
        });
    };

    const handleCloseContextMenu = () => {
        setContextMenu(null);
    };

    const handleUpdateRamp = async (finishedFlg = false) => {
        if (!contextMenu?.ramp) return;

        try {
            const rampId = contextMenu.ramp.LOCATIONID;
            const bookingsForRamp = yardBookings.filter(booking =>
                booking.BOOKINGTASKS?.some(task =>
                    task.LOCATIONID === rampId ||
                    task.PENDING_LOCATIONID === rampId
                )
            );
            if (bookingsForRamp.length === 0) {
                // console.log("No bookings found for this ramp");
                return;
            }
            const requestBody = {
                finishedFlg: finishedFlg,
                WarehouseId: selectedWarehouseId,
                BookingId: bookingsForRamp[0].BOOKINGID,
                BookingTasks: bookingsForRamp[0].BOOKINGTASKS
                    .filter(task =>
                        task.LOCATIONID === rampId ||
                        task.PENDING_LOCATIONID === rampId
                    )
                    .map(task => ({
                        BookingTaskId: task.BOOKINGTASKID,
                        LocationId: rampId
                    }))
            }
            const url = `${serverUrl}/api/LoadingBooking`;
            const response = await callApi("POST", url, props.userToken, requestBody);
            if (!response) {
                setError("No response received from server");
            }
            handleCloseContextMenu();
            await handleRefresh();
        } catch (error) {
            setError("❌ Update ramp error: " + (error.message || error.toString()));
        }
    };

    const handleCancelLoad = async (bookingId, bookingTaskId) => {
        if (!bookingId || !bookingTaskId) {
            setError("Missing BookingId or BookingTaskId");
            return;
        }
        if (!yardPositions.find(pos => pos.LOCATIONTYPE === 2)) {
            setError("Missing Location Parking");
            return;
        }
        const body = [
            {
                BookingId: bookingId,
                BookingTasks: [
                    {
                        BookingTaskId: bookingTaskId,
                        LocationId: yardPositions.find(pos => pos.LOCATIONTYPE === 2)?.LOCATIONID || null,
                    }
                ]
            }
        ];

        try {
            const url = `${serverUrl}/api/CancelLoad`;
            try {
                await callApi("POST", url, props.userToken, body);
            } catch (err) {
                if (err.message.includes("Unexpected end of JSON input")) {
                    console.warn("Empty response body - treating as success");
                } else {
                    throw err;
                }
            }
            await handleRefresh();

        } catch (error) {
            console.error("Error posting to CancelLoad API:", error);
            setError("❌ CancelLoad API call error: " + (error.message || error.toString()));
        }
    };

    const fetchYardBookings = React.useCallback(async () => {
        if (!selectedWarehouseId || !selectedZoneId) return;
        setRefreshing(true);
        try {

            const fromDate = format(subMonths(new Date(), 1), "yyyy-MM-dd");
            const url = `${serverUrl}/api/Yarda/Bookings?fromDateTime=${fromDate}&warehouseId=${selectedWarehouseId}&zoneId=${selectedZoneId}`;

            const result = await callApi("GET", url, props.userToken);
            setYardBookings(result || []);
            console.log("Fetched yard bookings:", result);
        } catch (error) {
            setError("❌ YardaBookings API call error: " + (error.message || error.toString()));
            setYardBookings([]);
        } finally {
            setRefreshing(false);
        }
    }, [selectedWarehouseId, selectedZoneId, serverUrl, props.userToken]);

    const fetchRamps = React.useCallback(async () => {
        if (!selectedWarehouseId) return;
        if (!selectedZoneId) return;
        setLoadingRamps(true);
        try {
            const url = `${serverUrl}/api/Yarda/Locations?warehouseId=${selectedWarehouseId}&zoneId=${selectedZoneId}&allRamps=${showAllZones ? 1 : 0}`;
            const response = await callApi("GET", url, props.userToken);
            setYardPositions(response || []);
            setRampsLoaded(true);
            // console.log("Fetched yard positions:", response);
        } catch (error) {
            setError("❌ YardaLocations API call error: " + (error.message || error.toString()));
            setYardPositions([]);
        } finally {
            setLoadingRamps(false);
        }
    }, [selectedWarehouseId, selectedZoneId, showAllZones, serverUrl, props.userToken]);

    const handleRefresh = React.useCallback(async () => {
        await Promise.all([fetchRamps(), fetchYardBookings()]);
    }, [fetchRamps, fetchYardBookings]);

    useEffect(() => {
        if (!ws) return;
        const handler = async (event) => {
            try {
                if (event?.type === "refreshdata") {
                    // console.log("Received from server:", event);
                    await handleRefresh();
                }
            } catch (e) {
                setError(e.message);
            }
        };
        ws.on("refreshdata", handler);
        return () => ws.off("refreshdata", handler);
    }, [ws, handleRefresh]);

    useEffect(() => {
        handleRefresh();
    }, [handleRefresh]);

    useEffect(() => {
        async function getDefaultLayouts() {
            if (!serverUrl) return;
            if (!allColumnsObj || (Object.keys(allColumnsObj).length === 0)) {
                let allobj = await loadListAllObjects(serverUrl, props.userToken)
                setAllColumnsObj(allobj);
            }
        }
        getDefaultLayouts();
    }, [serverUrl, props.userToken, allColumnsObj]);


    useEffect(() => {
        Object.values(timeoutRefs.current).forEach(clearTimeout);
        timeoutRefs.current = {};

        const now = new Date();
        const map = {};

        for (const ramp of yardPositions.filter(r => r.LOCATIONTYPE === 3)) {
            const taskWithDeadline = yardBookings.flatMap(b => {
                return b.BOOKINGTASKS?.map(task => ({
                    task,
                    booking: b
                })) || [];
            }).find(({ task }) =>
                task.PENDING_LOCATIONID === ramp.LOCATIONID && task.STATUS === 1
            );
            if (taskWithDeadline) {
                const { task } = taskWithDeadline;
                const smsDate = new Date(task.SMSDATE);
                const deadline = new Date(smsDate.getTime() + task.WAITINGTIME * 60 * 1000);
                const msUntilDeadline = deadline - now;

                if (msUntilDeadline <= 0) {
                    map[ramp.LOCATIONID] = true;
                } else {
                    map[ramp.LOCATIONID] = false;
                    timeoutRefs.current[ramp.LOCATIONID] = setTimeout(() => {
                        setHasTimePassedMap(prev => ({
                            ...prev,
                            [ramp.LOCATIONID]: true
                        }));
                    }, msUntilDeadline);
                }
            } else {
                map[ramp.LOCATIONID] = false;
            }
        }

        setHasTimePassedMap(map);

        return () => {
            Object.values(timeoutRefs.current).forEach(clearTimeout);
        };
    }, [yardBookings, yardPositions]);

    const handleDragEnd = async (event) => {
        const { over, active } = event;
        setIsDragging(false);

        if (!over) return;
        if (clickedTasks.length === 0) {
            setError(t('truckJourney.selectTaskBeforeDrag', language) || "You need to pick a task before you drag");
            return;
        }

        let BookingId = active.data.current?.truck?.BOOKINGID;
        const rampId = over.data.current?.ramp?.LOCATIONID;
        if (!BookingId || !rampId) return;

        let originalBookingId = BookingId;
        if (active.data.current?.truck?.TRUCKTYPE === 2) {
            const parentBooking = yardBookings.find(b =>
                b.TRUCKTYPE === 2 && b.BOOKINGTASKS?.some(task => task.BOOKINGTASKID === BookingId)
            );
            if (!parentBooking) return;

            originalBookingId = BookingId;
            BookingId = parentBooking.BOOKINGID;
        }

        let task;
        if (active.data.current?.truck?.TRUCKTYPE === 2) {
            task = clickedTasksRef.current.find(t => t.bookingTaskId === originalBookingId);
        } else {
            const booking = yardBookings.find(b => b.BOOKINGID === BookingId);
            if (booking && booking.BOOKINGTASKS && booking.BOOKINGTASKS.length > 0) {
                task = clickedTasksRef.current.find(t =>
                    booking.BOOKINGTASKS.some(bookingTask => bookingTask.BOOKINGTASKID === t.bookingTaskId)
                );
            }
        }
        if (!task) {
            setError(t('yardView.errorNoTaskForDraggedTruck', language));
            return;
        }
        const body = [
            {
                BookingId: BookingId,
                BookingTasks: [
                    {
                        BookingTaskId: task.bookingTaskId,
                        LocationId: rampId
                    }
                ]
            }
        ];

        try {
            const url = `${serverUrl}/api/Yarda/ReadyToLoad`;
            try {
                await callApi("POST", url, props.userToken, body);
            } catch (err) {
                if (err.message.includes("Unexpected end of JSON input")) {
                    console.warn("Empty response body - treating as success");
                } else {
                    throw err;
                }
            }
            const draggedBooking = yardBookings.find(b => b.BOOKINGID === BookingId);
            if (draggedBooking && (!draggedBooking.BOK_PHONE && !draggedBooking.DRIVER_PHONE1)) {
                setError(t('yardView.errorNoPhoneForSms', language));
            }
            if (draggedBooking && (draggedBooking.BOK_PHONE || draggedBooking.DRIVER_PHONE1)) {
                const droppedRamp = yardPositions.find(r => r.LOCATIONID === rampId);
                const smsData = {
                    DRIVER_NAME: draggedBooking.DRIVER_NAME,
                    mobile: (draggedBooking.BOK_PHONE || draggedBooking.DRIVER_PHONE1),
                    Ramp_DESCR1: (droppedRamp?.DESCR1 || droppedRamp?.LOCATIONCODE || rampId),
                    WarehouseId: selectedWarehouseId,
                    BookingTaskId: task.bookingTaskId
                };

                try {
                    await handleSendSms(smsData);
                } catch (smsError) {
                    console.warn("SMS sending failed, but drop was successful:", smsError);
                }
            }
            await handleRefresh();
        } catch (error) {
            console.error("Error posting to ReadyToLoad API:", error);
            setError("❌ ReadyToLoad API call error: " + (error.message || error.toString()));
        }
    };

    const handleSendSms = async (event) => {
        const textMessage = `${event.DRIVER_NAME || "Χαίρεται"}, η ράμπα σας είναι η ${event.Ramp_DESCR1}. Παρακαλώ κινηθείτε προς το σημείο. Ευχαριστούμε.`;
        try {
            const url = `${serverUrl}/api/Yarda/SendMessage`;
            const body = [{
                warehouseid: event.WarehouseId,
                mobile: event.mobile,
                text: textMessage,
                bookingTaskId: event.BookingTaskId
            }];
            // console.log(body)
            try {
                await callApi("POST", url, props.userToken, body);
                await handleRefresh();
            } catch (err) {
                if (err.message.includes("Unexpected end of JSON input")) {
                    setError("Empty response body - treating as success");
                } else {
                    setError("SendMessage API error: " + (err.message || err.toString()));
                    throw err;
                }
            }
        } catch (error) {
            console.error("Error posting to handleSendSms API:", error);
            setError("❌ handleSendSms error: " + (error.message || error.toString()));
            throw error;
        }
    };

    useEffect(() => {
        if (!selectedWarehouseId && data["Yms_Warehouses"]?.length > 0) {
            setSelectedWarehouseId(data["Yms_Warehouses"][0].WarehouseId);
        }
    }, [selectedWarehouseId, data]);


    const getTruckDisplayText = (booking) => {
        return getTruckDisplayTextHelper(booking, showSupplier);
    };

    const dropDowSelectChange = (newWarehouseId) => {
        setSelectedWarehouseId(Number(newWarehouseId));
    };

    const changeSelectedZoneId = (zoneId) => {
        setSelectedZoneId(Number(zoneId));
        setShowAllZones(false);
    };

    const handleShowAllZones = () => {
        setShowAllZones(!showAllZones);
    };

    useEffect(() => {
        async function getZonesForWarehouse() {
            if (!selectedWarehouseId || !allColumnsObj?.Yms_Zones || !userid) return;

            try {
                const objectName = "Yms_Zones";
                let prms = [];
                let prmValues = {};

                let defaultVariables = {
                    filterName: "customfilter",
                    appendFilter: "{YmsZon.WarehouseId} =?(;n;5;p_WarehouseId) AND EXISTS (SELECT 1 FROM Yms_UserZones uz WHERE uz.ZoneId = {YmsZon.ZoneId} AND uz.UserId = ?(;n;5;p_UserId))"
                };

                prms.push({ parameterName: "p_WarehouseId", type: "" });
                prms.push({ parameterName: "p_UserId", type: "" });
                prmValues["p_WarehouseId"] = selectedWarehouseId;
                prmValues["p_UserId"] = userid;

                const responseObj = await loadDataObject(
                    serverUrl,
                    props.userToken,
                    objectName,
                    allColumnsObj,
                    prms,
                    prmValues,
                    defaultVariables
                );

                setZonesByWarehouse(responseObj);
                setSelectedZoneId(responseObj[0]?.ZoneId || null);
            } catch (error) {
                setError("❌ Yms_Zones API call error: " + (error.message || error.toString()));
                setZonesByWarehouse([]);
            }
        }

        getZonesForWarehouse();
    }, [selectedWarehouseId, allColumnsObj, serverUrl, props.userToken, userid]);

    useEffect(() => {
        const rampRow = document.querySelector('.ramp-row2');

        if (rampRow) {
            const handleWheel = (e) => {
                if (rampRow.scrollWidth > rampRow.clientWidth) {
                    e.preventDefault();
                    rampRow.scrollLeft += e.deltaY;
                }
            };

            rampRow.addEventListener('wheel', handleWheel, { passive: false });

            return () => {
                rampRow.removeEventListener('wheel', handleWheel);
            };
        }
    }, [yardPositions]);


    useEffect(() => {
        async function getWarehouses() {
            if (!userid) return;
            const objectName = "Yms_Warehouses";
            if (Object.keys(allColumnsObj).length === 0) return;
            let prms = [];
            let prmValues = {};
            let defaultVariables = {
                "filterName": "customfilter",
                "top": 50
            }
            if (app.sessionToken?.Role === 'Admin') {
                if (app.sessionToken?.WarehouseId === null || app.sessionToken?.WarehouseId === '') {
                    defaultVariables["appendFilter"] = "{WarehouseId} IN (SELECT WAREHOUSEID FROM YMS_USERSWAREHOUSES WHERE USERID = ?(;n;5;p_UserId) AND ACTIVEFLG=1)";
                    prms.push({ "parameterName": "p_UserId", "type": "" });
                    prmValues["p_UserId"] = userid;
                }
                else {
                    defaultVariables["appendFilter"] = "{WarehouseId} =?(;n;5;p_WarehouseId)";
                    prms.push({ "parameterName": "p_WarehouseId", "type": "" });
                    prmValues["p_WarehouseId"] = app.sessionToken.WarehouseId;
                }
            }
            const responseObj = await loadDataObject(serverUrl, props.userToken, objectName, allColumnsObj, prms, prmValues, defaultVariables);
            setData(prev => {
                prev = { ...prev };
                prev[objectName] = responseObj
                return prev;
            });
        }
        getWarehouses();
    }, [userid, allColumnsObj, serverUrl, app.sessionToken, props.userToken]);

    useEffect(() => {
        async function getDefaultwarehouse() {
            if (app.sessionToken?.WarehouseId !== null && app.sessionToken.WarehouseId !== "") {
                setDefaultwarehouseId(app.sessionToken.WarehouseId);
                setSelectedWarehouseId(app.sessionToken.WarehouseId);
            }
        }
        getDefaultwarehouse();
    }, [app.sessionToken]);



    // const rampCount = yardPositions.filter(pos => pos.LOCATIONTYPE === 3);
    // const parkingSlots = yardPositions.filter(pos => pos.LOCATIONTYPE === 2);

    // const extraRampWidth = Math.max(0, rampCount.length - 23) * 54;
    // const extraParkingWidth = Math.max(0, parkingSlots.length - 46) * 25;

    // const mainContainerWidth = 1295 + extraRampWidth + extraParkingWidth;

    // const arrivalSlots = yardPositions.filter(pos => pos.LOCATIONTYPE === 1); 

    const rampTask = contextMenu?.ramp ?
        yardBookings.flatMap(b => b.BOOKINGTASKS || [])
            .find(task => task.LOCATIONID === contextMenu.ramp.LOCATIONID && task.STATUS === 2)
        : null;

    const parsedCustomStyle = app.sessionToken?.CustomStyle
        ? JSON.parse(app.sessionToken.CustomStyle)
        : {};

    const logoPath = parsedCustomStyle.Logo
        ? `${app.serverUrl}${parsedCustomStyle.Logo}`
        : '/images/Entersoft-Softone-Logo-Login.png';

    const handleDragStart = useCallback(() => {
        if (clickedTasks.length === 0) {
            setError(t('truckJourney.selectTaskBeforeDrag', language) || "You need to pick a task before you drag");
            return false;
        }
        setIsDraggingOverRampRow2(false);
        setIsDragging(true);
        setSelectedBookingId(null);
        setSelectedBookingDetails(null);
    }, [clickedTasks.length, language]);

    const handleDragOver = useCallback((event) => {
        const { over } = event;
        if (over) {
            const allRamps = yardPositions.filter(ramp => ramp.LOCATIONTYPE === 3);
            const rampsPerRow = calculateRampsPerRow();
            const rampIndex = allRamps.findIndex(ramp => ramp.LOCATIONID === over.data.current?.ramp?.LOCATIONID);
            const isRampRow2 = rampIndex >= rampsPerRow;
            setIsDraggingOverRampRow2(isRampRow2);
        } else {
            setIsDraggingOverRampRow2(false);
        }
    }, [yardPositions, calculateRampsPerRow]);

    const handleDragCancel = useCallback(() => {
        setIsDragging(false);
    }, []);

    return (
        <>


            <ErrorAlert message={error} setMessage={setError} language={language} />
            <div className="container-yard-view-status">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="calendar-container-pick">
                        <button style={{ padding: "3px" }} onClick={handleRefresh} disabled={refreshing}>
                            {refreshing ? t('truckJourney.loading', language) : <RefreshIcon />}
                        </button>
                        <WarehouseFilter
                            data={data}
                            selectedWarehouseId={selectedWarehouseId}
                            defaultwarehouseId={defaultwarehouseId}
                            language={language}
                            onChange={dropDowSelectChange}
                        />
                        {zonesByWarehouse.length > 0 ? (
                            <ZoneFilter
                                zonesByWarehouse={zonesByWarehouse}
                                selectedZoneId={selectedZoneId}
                                showAllZones={showAllZones}
                                language={language}
                                onChangeZone={changeSelectedZoneId}
                                onShowAllZones={handleShowAllZones}
                            />
                        ) : (
                            rampsLoaded && yardPositions.length === 0 && (
                                <span className="no-filter slide-in-left">{t('truckJourney.noZonesMessage', language)}</span>
                            )
                        )}
                    </div>
                    <TruckToggleButton
                        showSupplier={showSupplier}
                        setShowSupplier={setShowSupplier}
                        language={language}
                        t={t}
                    />
                </div>
            </div>
            <DndContext
                onDragStart={handleDragStart}
                onDragOver={handleDragOver}
                onDragEnd={handleDragEnd}
                onDragCancel={handleDragCancel}
                onClick={handleCloseContextMenu}
            >
                {selectedBookingIdArrival && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            pointerEvents: 'none',
                            zIndex: 999999
                        }}
                    >
                        <div
                            className="toolkit-popup-arrival"
                            style={{
                                position: 'relative',
                                top: tooltipPosition.y + 37,
                                left: tooltipPosition.x - 25,
                            }}
                            onMouseLeave={(e) => {
                                if (!e.relatedTarget ||
                                    !e.relatedTarget.closest ||
                                    !e.relatedTarget.closest('.toolkit-popup-arrival')) {
                                    setSelectedBookingIdArrival(null);
                                    setSelectedBookingDetails(null);
                                }
                            }}
                        >
                            {selectedBookingDetails}
                        </div>
                    </div>
                )}
                {selectedBookingId && !isDragging && (
                    <div
                        key={tooltipKey}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            pointerEvents: 'auto',
                            zIndex: 999999
                        }}
                    >
                        <div
                            className="toolkit-popup-arrival"
                            style={{
                                position: 'relative',
                                top: tooltipPosition.isHalfSlot ? tooltipPosition.y - 50 : tooltipPosition.y - 20,
                                left: tooltipPosition.x - 150,
                                transform: 'translate(0, 0)',
                            }}
                            onMouseLeave={(e) => {
                                if (!e.relatedTarget ||
                                    !e.relatedTarget.closest ||
                                    !e.relatedTarget.closest('.toolkit-popup-arrival')) {
                                    setSelectedBookingId(null);
                                    setSelectedBookingDetails(null);
                                }
                            }}
                        >
                            {selectedBookingDetails && (() => {
                                if (selectedBookingDetails.type === 'task') {
                                    const { data: task, isPending, arrivalId } = selectedBookingDetails;
                                    return (
                                        <div>
                                            <h6 className="mb-3">{t('truckJourney.rampAssignment', language)}</h6>
                                            {arrivalId && (
                                                <Typography variant="body2" fontWeight="bold" paddingBottom={1}>
                                                    <i className="bi bi-box-arrow-in-right" style={{ marginRight: "5px" }}></i>
                                                    Arrival ID: {arrivalId}
                                                </Typography>
                                            )}
                                            <div className="container-toolkit-truck">
                                                <span onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleTaskClick(task.BOOKINGTASKID);
                                                }}>
                                                    <Typography variant="body2" fontWeight="bold" className="mb-2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                                        <i className="bi bi-lightning-charge" style={{ marginRight: '8px' }}></i>
                                                        {t('ModalBooking.yardTaskType', language)}: {task.TASK_DESCR1 ? task.TASK_DESCR1 : "-"}
                                                    </Typography>
                                                    <Typography variant="body2" fontWeight="bold" className="mb-2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                                        <i className="bi bi-box" style={{ marginRight: '8px' }}></i>
                                                        {t('ModalBooking.categoryTitleForm', language)}: {task.CAT_DESCR1 ? task.CAT_DESCR1 : "-"}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : '#666' }}>
                                                        <i className="bi bi-columns-gap" style={{ marginRight: '8px' }}></i>
                                                        {t('ModalBooking.palletCountTitleForm', language)}: {task.PALLETS ? task.PALLETS : "-"}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : '#666' }}>
                                                        <i className="bi bi-boxes" style={{ marginRight: '8px' }}></i>
                                                        {t('ModalBooking.itemCountTitleForm', language)}: {task.COUNTOFITEMS ? task.COUNTOFITEMS : "-"}
                                                    </Typography>
                                                </span>
                                                {isPending ? (
                                                    <span className="d-flex justify-content-center align-items-center tasks-icon-yard">
                                                        <span>{t('truckJourney.loading', language)}</span>
                                                        <AccessTimeIcon />
                                                    </span>
                                                ) : (
                                                    <span onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleTaskClick(task.BOOKINGTASKID);
                                                    }}>
                                                        {clickedTasks.find(t => t.bookingTaskId === task.BOOKINGTASKID) ? (
                                                            <LocalShippingIcon className="clicked-truck-for-ramp" />
                                                        ) : (
                                                            <LocalShippingOutlinedIcon className="clicked-truck-for-ramp" />
                                                        )}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    );
                                } else if (selectedBookingDetails.type === 'booking') {
                                    const { bookingTasks, pendingTask, queueTasks, hasPending } = selectedBookingDetails;
                                    return (
                                        <div>
                                            <h6 className="mb-3">{t('truckJourney.rampAssignment', language)}</h6>
                                            {selectedBookingDetails?.data?.ARRIVALID && (
                                                <Typography variant="body2" fontWeight="bold" paddingBottom={1}>
                                                    <i className="bi bi-box-arrow-in-right" style={{ marginRight: "5px" }}></i>
                                                    Arrival ID: {selectedBookingDetails?.data?.ARRIVALID}
                                                </Typography>
                                            )}
                                            {pendingTask && (
                                                <div className="container-toolkit-truck">
                                                    <span>
                                                        <Typography variant="body2" fontWeight="bold" className="mb-2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                                            <i className="bi-lightning-charge" style={{ marginRight: '8px' }}></i>
                                                            {t('ModalBooking.yardTaskType', language)}: {pendingTask.TASK_DESCR1 ? pendingTask.TASK_DESCR1 : "-"}
                                                        </Typography>
                                                        <Typography variant="body2" fontWeight="bold" className="mb-2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                                            <i className="bi bi-box" style={{ marginRight: '8px' }}></i>
                                                            {t('ModalBooking.categoryTitleForm', language)}: {pendingTask.CAT_DESCR1 ? pendingTask.CAT_DESCR1 : "-"}
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : '#666' }}>
                                                            <i className="bi bi-columns-gap" style={{ marginRight: '8px' }}></i>
                                                            {t('ModalBooking.palletCountTitleForm', language)}: {pendingTask.PALLETS ? pendingTask.PALLETS : "-"}
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : '#666' }}>
                                                            <i className="bi bi-boxes" style={{ marginRight: '8px' }}></i>
                                                            {t('ModalBooking.itemCountTitleForm', language)}: {pendingTask.COUNTOFITEMS ? pendingTask.COUNTOFITEMS : "-"}
                                                        </Typography>
                                                    </span>
                                                    <span className="d-flex justify-content-center align-items-center tasks-icon-yard">
                                                        {bookingTasks.find(t => typeof t.STATUS === 'number' && t.STATUS === 2) && <span>Φόρτωση...</span>}
                                                        <AccessTimeIcon />
                                                    </span>
                                                </div>
                                            )}
                                            {queueTasks.length > 0 && (
                                                <>
                                                    {queueTasks.length === 1 && !hasPending && (() => {
                                                        const singleTask = queueTasks[0];
                                                        if (!clickedTasks.find(t => t.bookingTaskId === singleTask.BOOKINGTASKID)) {
                                                            handleTaskClick(singleTask.BOOKINGTASKID);
                                                        }
                                                    })()}
                                                    {queueTasks.map(task => (
                                                        <div className="container-toolkit-truck" key={task.BOOKINGTASKID}>
                                                            <span onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleTaskClick(task.BOOKINGTASKID);
                                                            }}>
                                                                <Typography variant="body2" fontWeight="bold" className="mb-2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                                                    <i className="bi bi-lightning-charge" style={{ marginRight: '8px' }}></i>
                                                                    {t('ModalBooking.yardTaskType', language)}: {task.TASK_DESCR1 ? task.TASK_DESCR1 : "-"}
                                                                </Typography>
                                                                <Typography variant="body2" fontWeight="bold" className="mb-2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                                                    <i className="bi bi-box" style={{ marginRight: '8px' }}></i>
                                                                    {t('ModalBooking.categoryTitleForm', language)}: {task.CAT_DESCR1 ? task.CAT_DESCR1 : "-"}
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : '#666' }}>
                                                                    <i className="bi bi-columns-gap" style={{ marginRight: '8px' }}></i>
                                                                    {t('ModalBooking.palletCountTitleForm', language)}: {task.PALLETS ? task.PALLETS : "-"}
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : '#666' }}>
                                                                    <i className="bi bi-boxes" style={{ marginRight: '8px' }}></i>
                                                                    {t('ModalBooking.itemCountTitleForm', language)}: {task.COUNTOFITEMS ? task.COUNTOFITEMS : "-"}
                                                                </Typography>
                                                            </span>
                                                            {!hasPending && (
                                                                <span onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleTaskClick(task.BOOKINGTASKID);
                                                                }}>
                                                                    {clickedTasks.find(t => t.bookingTaskId === task.BOOKINGTASKID) ? (
                                                                        <LocalShippingIcon className="clicked-truck-for-ramp" />
                                                                    ) : (
                                                                        <LocalShippingOutlinedIcon className="clicked-truck-for-ramp" />
                                                                    )}
                                                                </span>
                                                            )}
                                                        </div>
                                                    ))}
                                                </>
                                            )}
                                        </div>
                                    );
                                }
                                return null;
                            })()}
                        </div>
                    </div>
                )}
                <div className="overall-container" style={{
                    '--text-occupied': `"${t('yardView.occupied', language)}"`,
                    '--text-closed': `"${t('yardView.closed', language)}"`
                }}>
                    {loadingRamps && (
                        <div className="loading-message">
                            <Loading />
                        </div>
                    )}
                    <div className="arrival-container">
                        {(() => {
                            const arrivalBookings = yardBookings
                                .map(booking => {
                                    const task = booking.BOOKINGTASKS.find(task =>
                                        yardPositions.some(p => p.LOCATIONID === task.LOCATIONID && p.LOCATIONTYPE === 1)
                                    );
                                    if (!task) return null;

                                    const pos = yardPositions.find(p => p.LOCATIONID === task.LOCATIONID && p.LOCATIONTYPE === 1);
                                    return pos ? { booking, pos } : null;
                                })
                                .filter(Boolean);
                            if (arrivalBookings.length === 0) {
                                return (
                                    <div className="no-booking-message">
                                        <div className="message-content">
                                            <InboxIcon sx={{
                                                width: "17%",
                                                height: "17%",
                                                color: "rgba(255, 255, 255, 0.8)",
                                                mb: 1
                                            }} />
                                            <span>{t('truckJourney.noArrivalsMessage', language)}</span>
                                        </div>
                                    </div>
                                );
                            }
                            return arrivalBookings.flatMap(({ booking, pos }, index) => {
                                if (booking.TRUCKTYPE === 2) {
                                    return booking.BOOKINGTASKS.map((task, i) => (
                                        <div key={`booking-${booking.BOOKINGID}-task-${task.BOOKINGTASKID}-${i}`} className="arrival-slot">
                                            {pos.NAME || `Α${index + 1}.${i + 1}`}
                                            <div
                                                className="truck-svg-wrapper arrival"
                                                onMouseEnter={(e) => {
                                                    const rect = e.currentTarget.getBoundingClientRect();
                                                    setTooltipPosition({
                                                        x: rect.right,
                                                        y: rect.top + rect.height / 2
                                                    });
                                                    setHoveredTruckIndex(i);
                                                    setSelectedBookingIdArrival(booking.BOOKINGID);
                                                    setSelectedBookingDetails(
                                                        <Box
                                                            sx={{
                                                                borderRadius: '11px',
                                                                fontSize: '14px',
                                                                color: app.theme === 'dark' ? 'var(--text-secondary)' : '#333',
                                                                backgroundColor: app.theme === 'dark' ? 'var(--bg-primary)' : 'white',
                                                                padding: '10px',
                                                            }}
                                                        >
                                                            <h6>{t('yardView.titleArrival', language)}</h6>
                                                            <Box
                                                                sx={{
                                                                    borderRadius: '11px',
                                                                    fontSize: '14px',
                                                                    color: app.theme === 'dark' ? 'var(--text-secondary)' : '#333',
                                                                    backgroundColor: app.theme === 'dark' ? 'var(--bg-primary)' : 'white',
                                                                    marginBottom: '10px'
                                                                }}
                                                            >
                                                                <Typography variant="body2" fontWeight="bold">
                                                                    <i className="bi bi-clock" style={{ marginRight: '8px' }}></i>
                                                                    {booking.FROMDATE ?
                                                                        new Date(booking.FROMDATE).toLocaleString(undefined, {
                                                                            hour12: false,
                                                                            hour: '2-digit',
                                                                            minute: '2-digit',
                                                                            second: undefined
                                                                        })
                                                                        : "-"}
                                                                </Typography>
                                                                <Typography variant="body2" fontWeight="bold">
                                                                    <i className="bi bi-car-front" style={{ marginRight: '8px' }}></i>
                                                                    {booking.TRUCK_LICENSENO}
                                                                </Typography>
                                                                {booking.ARRIVALID && (
                                                                    <Typography variant="body2" fontWeight="bold">
                                                                        <i className="bi bi-box-arrow-in-right" style={{ marginRight: "5px" }}></i>
                                                                        Arrival ID: {booking.ARRIVALID}
                                                                    </Typography>
                                                                )}
                                                            </Box>
                                                            {booking.TRUCKTYPE === 2 && (
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        alignItems: 'flex-start',
                                                                        gap: '10px',
                                                                        padding: '5px 15px 15px 15px',
                                                                        backgroundColor: 'rgba(74, 144, 226, 0.1)',
                                                                        borderRadius: '8px',
                                                                        marginBottom: '10px',
                                                                        flexDirection: 'column'
                                                                    }}
                                                                >
                                                                    <Typography variant="body2">
                                                                        {t('yardView.semiTrailer', language)}
                                                                    </Typography>
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '40px',
                                                                        padding: '15px',
                                                                        width: '100%',
                                                                        height: '0',
                                                                        justifyContent: 'center'
                                                                    }} className="combined-delivery">
                                                                        {booking.BOOKINGTASKS.map((_, index) => (
                                                                            <React.Fragment key={`truck-icon-${booking.BOOKINGID}-${task.BOOKINGTASKID}-${index}`}>
                                                                                <div style={{
                                                                                    opacity: i === index ? 1 : 0.5,
                                                                                    padding: '2px',
                                                                                    borderRadius: '4px',
                                                                                    width: "50px",
                                                                                    height: '90px',
                                                                                    backgroundColor: i === index ? 'rgba(74, 144, 226, 0.2)' : 'transparent',
                                                                                    transform: 'rotate(-90deg)',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center'
                                                                                }}>
                                                                                    {index === 0 ? (
                                                                                        <TruckSVG style={{ width: '100%', height: '100%' }} />
                                                                                    ) : (
                                                                                        <TruckCargoSVG style={{ width: '100%', height: '100%' }} />
                                                                                    )}
                                                                                </div>
                                                                            </React.Fragment>
                                                                        ))}
                                                                    </div>

                                                                </Box>
                                                            )
                                                            }

                                                            {booking.BOOKINGTASKS.map((bookingTask, index) => (
                                                                <div key={`task-details-${booking.BOOKINGID}-${bookingTask.BOOKINGTASKID}-${index}`}>
                                                                    {index > 0 && (
                                                                        <Divider
                                                                            sx={{
                                                                                width: '100%',
                                                                                my: 1,
                                                                                borderColor: 'rgba(0, 0, 0, 0.12)'
                                                                            }}
                                                                        />
                                                                    )}
                                                                    <Box
                                                                        display="flex"
                                                                        flexDirection="column"
                                                                        alignItems="flex-start"
                                                                        justifyContent="space-between"
                                                                        width="100%"
                                                                        padding="5px"
                                                                        mb={1.5}
                                                                        sx={{
                                                                            outline: i === index ? '2px solid #A6D4FF' : 'unset',
                                                                            borderRadius: '8px',
                                                                            padding: '5px 12px',
                                                                        }}
                                                                    >
                                                                        <Typography variant="body2" fontWeight="bold" className="mb-2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                                                            <i className="bi bi-lightning-charge" style={{ marginRight: '8px' }}></i>
                                                                            {t('ModalBooking.yardTaskType', language)}: {bookingTask.TASK_DESCR1 ? bookingTask.TASK_DESCR1 : "-"}
                                                                        </Typography>
                                                                        <Typography variant="body2" fontWeight="bold" className="mb-2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                                                            <i className="bi bi-box" style={{ marginRight: '8px' }}></i>
                                                                            {t('ModalBooking.categoryTitleForm', language)}: {bookingTask.CAT_DESCR1 ? bookingTask.CAT_DESCR1 : "-"}
                                                                        </Typography>

                                                                        {bookingTask.PALLETS && (
                                                                            <Typography variant="body2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : '#666' }}>
                                                                                <i className="bi bi-columns-gap" style={{ marginRight: '8px' }}></i>
                                                                                {t('ModalBooking.palletCountTitleForm', language)}: {bookingTask.PALLETS ? bookingTask.PALLETS : "-"}
                                                                            </Typography>
                                                                        )}

                                                                        {bookingTask.COUNTOFITEMS && (
                                                                            <Typography variant="body2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : '#666' }}>
                                                                                <i className="bi bi-boxes" style={{ marginRight: '8px' }}></i>
                                                                                {t('ModalBooking.itemCountTitleForm', language)}: {bookingTask.COUNTOFITEMS ? bookingTask.COUNTOFITEMS : "-"}
                                                                            </Typography>
                                                                        )}
                                                                    </Box>
                                                                </div>
                                                            ))}
                                                        </Box>
                                                    );
                                                }
                                                }
                                                onMouseLeave={(e) => {
                                                    if (!e.relatedTarget || !e.relatedTarget.closest || !e.relatedTarget.closest('.toolkit-popup-arrival')) {
                                                        setSelectedBookingIdArrival(null);
                                                        setSelectedBookingDetails(null);
                                                        setHoveredTruckIndex(null);
                                                    }
                                                }}
                                            >
                                                <div style={{
                                                    filter: booking.TRUCKTYPE === 2 && selectedBookingIdArrival === booking.BOOKINGID ?
                                                        (i !== hoveredTruckIndex ?
                                                            'drop-shadow(4px 0px 6px #A6D4FF)' :
                                                            '') :
                                                        '',
                                                    transition: 'all 0.3s ease'
                                                }}>
                                                    {i === 0 ? <TruckSVG /> : <TruckCargoSVG />}
                                                </div>
                                                <span className="descr-for-truck">
                                                    {getTruckDisplayText(booking)}
                                                </span>
                                            </div>
                                        </div>
                                    ));
                                }

                                let className = "arrival-slot";
                                if (index === 0) className = "arrival-slot-first";
                                else if (index === arrivalBookings.length - 1) className = "arrival-slot-end";

                                return (
                                    <div key={booking.ID || index} className={className}>
                                        {pos.NAME || `Α${index + 1}`}
                                        <div
                                            className="truck-svg-wrapper arrival"
                                            onMouseEnter={(e) => {
                                                const rect = e.currentTarget.getBoundingClientRect();
                                                setTooltipPosition({
                                                    x: rect.right,
                                                    y: rect.top + rect.height / 2
                                                });
                                                setSelectedBookingIdArrival(booking.BOOKINGID);
                                                setSelectedBookingDetails(
                                                    <Box
                                                        sx={{
                                                            borderRadius: '11px',
                                                            fontSize: '14px',
                                                            color: app.theme === 'dark' ? 'var(--text-secondary)' : '#333',
                                                            backgroundColor: app.theme === 'dark' ? 'var(--bg-primary)' : 'white',
                                                        }}
                                                    >
                                                        <h6>  {t('yardView.titleArrival', language)}</h6>
                                                        <Box
                                                            sx={{
                                                                borderRadius: '11px',
                                                                fontSize: '14px',
                                                                color: app.theme === 'dark' ? 'var(--text-secondary)' : '#333',
                                                                backgroundColor: app.theme === 'dark' ? 'var(--bg-primary)' : 'white',
                                                            }}
                                                        >
                                                            <Typography variant="body2" fontWeight="bold">
                                                                <i className="bi bi-clock" style={{ marginRight: '8px' }}></i>
                                                                {booking.FROMDATE ?
                                                                    new Date(booking.FROMDATE).toLocaleString(undefined, {
                                                                        hour12: false,
                                                                        hour: '2-digit',
                                                                        minute: '2-digit',
                                                                        second: undefined
                                                                    })
                                                                    : "-"}
                                                            </Typography>
                                                            {booking.SUPPLIER_SHORTNAMES && <Typography variant="body2" fontWeight="bold">
                                                                <i className="bi bi-truck" style={{ marginRight: '8px' }}></i>
                                                                {booking.SUPPLIER_SHORTNAMES ? booking.SUPPLIER_SHORTNAMES : '-'}
                                                            </Typography>}
                                                            {booking.ARRIVALID && (
                                                                <Typography variant="body2" fontWeight="bold">
                                                                    <i className="bi bi-box-arrow-in-right" style={{ marginRight: "5px" }}></i>
                                                                    Arrival ID: {booking.ARRIVALID ? booking.ARRIVALID : '-'}
                                                                </Typography>
                                                            )}
                                                            <Typography variant="body2" fontWeight="bold">
                                                                <i className="bi bi-car-front" style={{ marginRight: '8px' }}></i>
                                                                {booking.TRUCK_LICENSENO ? booking.TRUCK_LICENSENO : '-'}
                                                            </Typography>
                                                        </Box>

                                                        {booking.BOOKINGTASKS.map((bookingTask, index) => (
                                                            <div key={index}>
                                                                {index > 0 && (
                                                                    <Divider
                                                                        sx={{
                                                                            width: '100%',
                                                                            my: 1,
                                                                            borderColor: 'rgba(0, 0, 0, 0.12)'
                                                                        }}
                                                                    />
                                                                )}
                                                                <Box
                                                                    display="flex"
                                                                    flexDirection="column"
                                                                    alignItems="flex-start"
                                                                    justifyContent="space-between"
                                                                    width="100%"
                                                                    padding="5px"
                                                                    mb={1.5}
                                                                >
                                                                    <Typography variant="body2" fontWeight="bold" className="mb-2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                                                        <i className="bi bi-lightning-charge" style={{ marginRight: '8px' }}></i>
                                                                        {t('ModalBooking.yardTaskType', language)}: {bookingTask.TASK_DESCR1 ? bookingTask.TASK_DESCR1 : "-"}
                                                                    </Typography>
                                                                    <Typography variant="body2" fontWeight="bold" className="mb-2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>
                                                                        <i className="bi bi-box" style={{ marginRight: '8px' }}></i>
                                                                        {t('ModalBooking.categoryTitleForm', language)}: {bookingTask.CAT_DESCR1 ? bookingTask.CAT_DESCR1 : "-"}
                                                                    </Typography>

                                                                    {bookingTask.PALLETS && (
                                                                        <Typography variant="body2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : '#666' }}>
                                                                            <i className="bi bi-columns-gap" style={{ marginRight: '8px' }}></i>
                                                                            {t('ModalBooking.palletCountTitleForm', language)}: {bookingTask.PALLETS ? bookingTask.PALLETS : "-"}
                                                                        </Typography>
                                                                    )}

                                                                    {bookingTask.COUNTOFITEMS && (
                                                                        <Typography variant="body2" sx={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : '#666' }}>
                                                                            <i className="bi bi-boxes" style={{ marginRight: '8px' }}></i>
                                                                            {t('ModalBooking.itemCountTitleForm', language)}: {bookingTask.COUNTOFITEMS ? bookingTask.COUNTOFITEMS : "-"}
                                                                        </Typography>
                                                                    )}
                                                                </Box>
                                                            </div>
                                                        ))}
                                                    </Box>
                                                );
                                            }}
                                            onMouseLeave={(e) => {
                                                if (!e.relatedTarget ||
                                                    !e.relatedTarget.closest ||
                                                    !e.relatedTarget.closest('.toolkit-popup-arrival')) {
                                                    setSelectedBookingIdArrival(null);
                                                    setSelectedBookingDetails(null);
                                                }
                                            }}
                                        >
                                            <TruckSVG />
                                            <span className="descr-for-truck">
                                                {getTruckDisplayText(booking)}
                                            </span>

                                        </div>
                                    </div>
                                );
                            });


                        })()}
                    </div>
                    <div className="gate-container"></div>
                    <div className="main-container" >
                        <ConnectionLines
                            yardBookings={yardBookings}
                            yardPositions={yardPositions}
                            calculateRampsPerRow={calculateRampsPerRow}
                        />
                        <div className="logo-and-container"><img src={`${logoPath}`}
                            alt={t('profile.companyLogoAlt', language)}
                            className="company-logo"
                        /></div>
                        <div className="concrete-under-the-ramps"></div>

                        <div className="ramp-row">
                            {(() => {
                                const allRamps = yardPositions.filter(ramp => ramp.LOCATIONTYPE === 3);
                                const rampsPerRow = calculateRampsPerRow();
                                const firstRowRamps = allRamps.slice(0, rampsPerRow);
                                return firstRowRamps.map((ramp, index) => {
                                    const bookingMatch = yardBookings.find(b =>
                                        b.BOOKINGTASKS?.some(task => Number(task.LOCATIONID) === Number(ramp.LOCATIONID))
                                    );


                                    const highlightClass =
                                        ramp.LOCATIONTYPE === 3 &&
                                            yardBookings.find(b =>
                                                b.BOOKINGTASKS?.some(
                                                    task =>
                                                        task.PENDING_LOCATIONID === ramp.LOCATIONID &&
                                                        (task.STATUS === 1)
                                                )
                                            )
                                            ? "highlight-yellow"
                                            : "";

                                    const truckHighlightClass =
                                        ramp.LOCATIONTYPE === 3 &&
                                            yardBookings.find(b =>
                                                b.BOOKINGTASKS?.some(
                                                    task =>
                                                        task.PENDING_LOCATIONID === ramp.LOCATIONID &&
                                                        (task.STATUS === 1)
                                                )
                                            )
                                            ? "truck-highlight"
                                            : "";

                                    const pendingBookingMatch =
                                        ramp.LOCATIONTYPE === 3
                                            ? yardBookings.find(b =>
                                                b.BOOKINGTASKS?.some(task =>
                                                    task.PENDING_LOCATIONID === ramp.LOCATIONID &&
                                                    task.STATUS === 1
                                                )
                                            )
                                            : null;


                                    const hasPendingBooking = yardBookings.some(b =>
                                        b.BOOKINGTASKS?.some(
                                            task =>
                                                task.PENDING_LOCATIONID === ramp.LOCATIONID &&
                                                task.STATUS === 1
                                        )
                                    );

                                    const hasBookingIdMatch = yardBookings.some(b =>
                                        b.BOOKINGID === ramp.LOCATIONID
                                    );

                                    const rampsIsNotActive = yardBookings.find(b =>
                                        b.BOOKINGTASKS?.some(task => task.LOCATIONID === ramp.LOCATIONID)
                                    );

                                    const statusClass =
                                        ramp.STATUS === 3 ? "closed" :
                                            (ramp.STATUS === 2 && (!rampsIsNotActive && !hasPendingBooking)) ? "ramp-empty-status2" :
                                                "";


                                    const handleRampContextMenu = (
                                        hasPendingBooking ||
                                        hasBookingIdMatch ||
                                        yardBookings.some(b =>
                                            b.BOOKINGTASKS?.some(task =>
                                                task.LOCATIONID === ramp.LOCATIONID &&
                                                (task.STATUS === 1 || task.STATUS === 2)
                                            )
                                        )
                                    )
                                        ? (e) => handleContextMenu(e, ramp)
                                        : undefined;

                                    const hasTimePassed = hasTimePassedMap[ramp.LOCATIONID];

                                    // Check if this ramp has a different zone ID than selected zone
                                    const isDifferentZone = showAllZones && ramp.ZONEID !== selectedZoneId;

                                    // const haveTrailer = bookingMatch?.TRUCKTYPE === 2;
                                    // let TruckIcon = TruckSVG;
                                    // let count = bookingMatch?.BOOKINGTASKS?.length > 1 || 0;
                                    // if (haveTrailer && bookingMatch?.TRUCKTYPE === 2) {
                                    //     TruckIcon = (count + 1) === 1 ? TruckSVG : TruckCargoSVG;
                                    // }
                                    return (
                                        <div
                                            key={ramp.ID || index}
                                        >

                                            <DroppableRamp ramp={ramp} statusClass={`${statusClass} ${isDifferentZone ? 'different-zone' : ''}`} onContextMenu={handleRampContextMenu}>
                                                {hasTimePassed && (
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            bottom: '2px',
                                                            left: '0',
                                                            right: '0',
                                                            textAlign: 'center',
                                                            color: '#F6CB54',
                                                            zIndex: 10,
                                                        }}
                                                    >
                                                        <CustomTooltip
                                                            arrow
                                                            title={
                                                                <div>
                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <strong style={{ fontSize: '15px' }}>{t('yardView.driverDelay', language)}:</strong>
                                                                        <WarningIcon style={{ color: '#F6CB54', marginRight: '8px', fontSize: "33px" }} />
                                                                    </div>
                                                                    <div style={{ color: '#757575', fontWeight: 500 }}>
                                                                        <strong><i className="bi bi-file-earmark-text" style={{ marginRight: "5px" }}></i>{pendingBookingMatch?.BOOKINGID || t('yardView.unknown', language)}</strong>
                                                                    </div>
                                                                    <div style={{ color: '#757575', fontWeight: 500 }}>
                                                                        <strong>{t('truckJourney.name', language)}:</strong> {pendingBookingMatch?.DRIVER_NAME || t('yardView.unknown', language)}
                                                                    </div>
                                                                    <div style={{ color: '#757575', fontWeight: 500, paddingBottom: "20px" }}>
                                                                        <strong>{t('truckJourney.licensePlate', language)}:</strong> {pendingBookingMatch?.TRUCK_LICENSENO || t('yardView.unknown', language)}
                                                                    </div>
                                                                    {(() => {
                                                                        const pendingTask = pendingBookingMatch?.BOOKINGTASKS?.find(
                                                                            task => task.PENDING_LOCATIONID === ramp.LOCATIONID && task.STATUS === 1
                                                                        );
                                                                        return pendingTask?.SMSDATE && (
                                                                            <div style={{ color: '#757575', fontWeight: 500, paddingBottom: "10px" }}>
                                                                                <strong>{t('yardView.lastSMSSent', language)}:</strong> {new Date(pendingTask.SMSDATE).toLocaleString(undefined, {
                                                                                    hour12: false,
                                                                                    hour: '2-digit',
                                                                                    minute: '2-digit',
                                                                                    second: '2-digit'
                                                                                })}
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                    <button
                                                                        className="btn-warning-yard"
                                                                        onClick={async (e) => {
                                                                            e.stopPropagation();
                                                                            if (pendingBookingMatch && (pendingBookingMatch.BOK_PHONE || pendingBookingMatch.DRIVER_PHONE1)) {
                                                                                const smsData = {
                                                                                    DRIVER_NAME: pendingBookingMatch.DRIVER_NAME,
                                                                                    mobile: (pendingBookingMatch.BOK_PHONE || pendingBookingMatch.DRIVER_PHONE1),
                                                                                    Ramp_DESCR1: (ramp.DESCR1 || ramp.LOCATIONCODE),
                                                                                    WarehouseId: pendingBookingMatch.WarehouseId || selectedWarehouseId,
                                                                                    BookingTaskId: pendingBookingMatch.BOOKINGTASKS.find(
                                                                                        task => task.PENDING_LOCATIONID === ramp.LOCATIONID && task.STATUS === 1
                                                                                    )?.BOOKINGTASKID
                                                                                };
                                                                                try {
                                                                                    await handleSendSms(smsData);
                                                                                } catch (smsError) {
                                                                                    console.warn("SMS resend failed:", smsError);
                                                                                }
                                                                            } else if (pendingBookingMatch && (!pendingBookingMatch.BOK_PHONE && !pendingBookingMatch.DRIVER_PHONE1)) {
                                                                                setError(t('yardView.errorNoPhoneForSms', language));
                                                                            }
                                                                        }}>
                                                                        {t('truckJourney.resendSMS', language)}
                                                                    </button>
                                                                </div>
                                                            }
                                                        >
                                                            <WarningIcon style={{ cursor: 'pointer' }} />
                                                        </CustomTooltip>
                                                    </div>
                                                )}
                                                <div className={`${highlightClass} ${hasTimePassed ? 'no-animation' : ''}`}></div>
                                                {!hasTimePassed && truckHighlightClass !== "" && (() => {
                                                    const tasks = pendingBookingMatch?.BOOKINGTASKS || [];
                                                    const taskForThisRamp = tasks.find(task => task.PENDING_LOCATIONID === ramp.LOCATIONID && task.STATUS === 1);
                                                    const taskIndex = tasks.findIndex(task => task.BOOKINGTASKID === taskForThisRamp?.BOOKINGTASKID);

                                                    const isTrailer = pendingBookingMatch?.TRUCKTYPE === 2 && tasks.length > 1;
                                                    const TruckIcon = isTrailer
                                                        ? (taskIndex === 0 ? TruckSVG : TruckCargoSVG)
                                                        : TruckSVG;

                                                    return (
                                                        <div className={`${truckHighlightClass}`}>
                                                            <span className="descr-for-truck" style={{ transform: "rotate(270deg)", textAlign: 'center', zIndex: 2, whiteSpace: 'nowrap', top: '14px', left: '-14px' }}>
                                                                {getTruckDisplayText(pendingBookingMatch)}
                                                            </span>
                                                            <TruckIcon />
                                                        </div>
                                                    );
                                                })()}
                                                <span className="location-code">
                                                    <div>{ramp.LOCATIONCODE || index + 1}</div>
                                                </span>
                                                {bookingMatch && (
                                                    <div className="truck-svg-wrapper ramp">
                                                        {(() => {
                                                            const tasks = bookingMatch.BOOKINGTASKS || [];
                                                            const taskForThisRamp = tasks.find(task => task.LOCATIONID === ramp.LOCATIONID);

                                                            const taskIndex = tasks.findIndex(task => task.BOOKINGTASKID === taskForThisRamp?.BOOKINGTASKID);

                                                            if (bookingMatch.TRUCKTYPE === 2 && tasks.length > 1) {
                                                                return (
                                                                    <>
                                                                        {taskIndex === 0 ? <TruckSVG /> : <TruckCargoSVG />}
                                                                        <div className="descr-for-truck-ramp">
                                                                            {getTruckDisplayText(bookingMatch)}
                                                                        </div>
                                                                    </>
                                                                );
                                                            }
                                                            return (
                                                                <>
                                                                    <TruckSVG />
                                                                    <div className="descr-for-truck-ramp">
                                                                        {getTruckDisplayText(bookingMatch)}
                                                                    </div>
                                                                </>
                                                            );
                                                        })()}
                                                    </div>
                                                )}
                                            </DroppableRamp>
                                        </div>
                                    );
                                })
                            })()}
                        </div>
                        {(() => {
                            const allRamps = yardPositions.filter(ramp => ramp.LOCATIONTYPE === 3);
                            const rampsPerRow = calculateRampsPerRow();
                            const secondRowRamps = allRamps.slice(rampsPerRow);
                            if (secondRowRamps.length === 0) {
                                return null;
                            }

                            return (
                                <>
                                    <div className="logo-and-container2">
                                    </div>
                                    <div className="concrete-under-the-ramps2"></div>
                                    <div className="ramp-row2">
                                        {secondRowRamps.map((ramp, index) => {
                                            const actualIndex = index + rampsPerRow;
                                            const bookingMatch = yardBookings.find(b =>
                                                b.BOOKINGTASKS?.some(task => Number(task.LOCATIONID) === Number(ramp.LOCATIONID))
                                            );

                                            const highlightClass =
                                                ramp.LOCATIONTYPE === 3 &&
                                                    yardBookings.find(b =>
                                                        b.BOOKINGTASKS?.some(
                                                            task =>
                                                                task.PENDING_LOCATIONID === ramp.LOCATIONID &&
                                                                (task.STATUS === 1)
                                                        )
                                                    )
                                                    ? "highlight-yellow"
                                                    : "";

                                            const truckHighlightClass =
                                                ramp.LOCATIONTYPE === 3 &&
                                                    yardBookings.find(b =>
                                                        b.BOOKINGTASKS?.some(
                                                            task =>
                                                                task.PENDING_LOCATIONID === ramp.LOCATIONID &&
                                                                (task.STATUS === 1)
                                                        )
                                                    )
                                                    ? "truck-highlight"
                                                    : "";

                                            const pendingBookingMatch =
                                                ramp.LOCATIONTYPE === 3
                                                    ? yardBookings.find(b =>
                                                        b.BOOKINGTASKS?.some(task =>
                                                            task.PENDING_LOCATIONID === ramp.LOCATIONID &&
                                                            task.STATUS === 1
                                                        )
                                                    )
                                                    : null;

                                            const hasPendingBooking = yardBookings.some(b =>
                                                b.BOOKINGTASKS?.some(
                                                    task =>
                                                        task.PENDING_LOCATIONID === ramp.LOCATIONID &&
                                                        task.STATUS === 1
                                                )
                                            );

                                            const hasBookingIdMatch = yardBookings.some(b =>
                                                b.BOOKINGID === ramp.LOCATIONID
                                            );

                                            const rampsIsNotActive = yardBookings.find(b =>
                                                b.BOOKINGTASKS?.some(task => task.LOCATIONID === ramp.LOCATIONID)
                                            );

                                            const statusClass =
                                                ramp.STATUS === 3 ? "closed" :
                                                    (ramp.STATUS === 2 && (!rampsIsNotActive && !hasPendingBooking)) ? "ramp-empty-status2" :
                                                        "";

                                            const handleRampContextMenu = (
                                                hasPendingBooking ||
                                                hasBookingIdMatch ||
                                                yardBookings.some(b =>
                                                    b.BOOKINGTASKS?.some(task =>
                                                        task.LOCATIONID === ramp.LOCATIONID &&
                                                        (task.STATUS === 1 || task.STATUS === 2)
                                                    )
                                                )
                                            )
                                                ? (e) => handleContextMenu(e, ramp)
                                                : undefined;

                                            const hasTimePassed = hasTimePassedMap[ramp.LOCATIONID];

                                            // Check if this ramp has a different zone ID than selected zone
                                            const isDifferentZone = showAllZones && ramp.ZONEID !== selectedZoneId;

                                            return (
                                                <div
                                                    key={ramp.ID || actualIndex}
                                                >
                                                    <DroppableRamp ramp={ramp} s statusClass={`${statusClass} ${isDifferentZone ? 'different-zone' : ''}`} onContextMenu={handleRampContextMenu}>
                                                        {hasTimePassed && (
                                                            <div
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '2px',
                                                                    left: '0',
                                                                    right: '0',
                                                                    textAlign: 'center',
                                                                    color: '#F6CB54',
                                                                    zIndex: 10,
                                                                }}
                                                            >
                                                                <CustomTooltip
                                                                    arrow
                                                                    title={
                                                                        <div>
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <strong style={{ fontSize: '15px' }}>{t('yardView.driverDelay', language)}:</strong>
                                                                                <WarningIcon style={{ color: '#F6CB54', marginRight: '8px', fontSize: "33px" }} />
                                                                            </div>
                                                                            <div style={{ color: '#757575', fontWeight: 500 }}>
                                                                                <strong><i className="bi bi-file-earmark-text" style={{ marginRight: "5px" }}></i>{pendingBookingMatch?.BOOKINGID || t('yardView.unknown', language)}</strong>
                                                                            </div>
                                                                            <div style={{ color: '#757575', fontWeight: 500 }}>
                                                                                <strong>{t('truckJourney.name', language)}:</strong> {pendingBookingMatch?.DRIVER_NAME || t('yardView.unknown', language)}
                                                                            </div>
                                                                            <div style={{ color: '#757575', fontWeight: 500, paddingBottom: "20px" }}>
                                                                                <strong>{t('truckJourney.licensePlate', language)}:</strong> {pendingBookingMatch?.TRUCK_LICENSENO || t('yardView.unknown', language)}
                                                                            </div>
                                                                            {(() => {
                                                                                const pendingTask = pendingBookingMatch?.BOOKINGTASKS?.find(
                                                                                    task => task.PENDING_LOCATIONID === ramp.LOCATIONID && task.STATUS === 1
                                                                                );
                                                                                return pendingTask?.SMSDATE && (
                                                                                    <div style={{ color: '#757575', fontWeight: 500, paddingBottom: "10px" }}>
                                                                                        <strong>{t('yardView.lastSMSSent', language)}:</strong> {new Date(pendingTask.SMSDATE).toLocaleString(undefined, {
                                                                                            hour12: false,
                                                                                            hour: '2-digit',
                                                                                            minute: '2-digit',
                                                                                            second: '2-digit'
                                                                                        })}
                                                                                    </div>
                                                                                );
                                                                            })()}
                                                                            <button
                                                                                className="btn-warning-yard"
                                                                                onClick={async (e) => {
                                                                                    e.stopPropagation();
                                                                                    if (pendingBookingMatch && (pendingBookingMatch.BOK_PHONE || pendingBookingMatch.DRIVER_PHONE1)) {
                                                                                        const smsData = {
                                                                                            DRIVER_NAME: pendingBookingMatch.DRIVER_NAME,
                                                                                            mobile: (pendingBookingMatch.BOK_PHONE || pendingBookingMatch.DRIVER_PHONE1),
                                                                                            Ramp_DESCR1: (ramp.DESCR1 || ramp.LOCATIONCODE),
                                                                                            WarehouseId: pendingBookingMatch.WarehouseId || selectedWarehouseId,
                                                                                            BookingTaskId: pendingBookingMatch.BOOKINGTASKS.find(
                                                                                                task => task.PENDING_LOCATIONID === ramp.LOCATIONID && task.STATUS === 1
                                                                                            )?.BOOKINGTASKID
                                                                                        };
                                                                                        try {
                                                                                            await handleSendSms(smsData);
                                                                                        } catch (smsError) {
                                                                                            console.warn("SMS resend failed:", smsError);
                                                                                        }
                                                                                    } else if (pendingBookingMatch && (!pendingBookingMatch.BOK_PHONE && !pendingBookingMatch.DRIVER_PHONE1)) {
                                                                                        setError(t('yardView.errorNoPhoneForSms', language));
                                                                                    }
                                                                                }}>
                                                                                {t('truckJourney.resendSMS', language)}
                                                                            </button>
                                                                        </div>
                                                                    }
                                                                >
                                                                    <WarningIcon style={{ cursor: 'pointer' }} />
                                                                </CustomTooltip>
                                                            </div>
                                                        )}
                                                        <div className={`${highlightClass} ${hasTimePassed ? 'no-animation' : ''}`}></div>
                                                        {!hasTimePassed && truckHighlightClass !== "" && (() => {
                                                            const tasks = pendingBookingMatch?.BOOKINGTASKS || [];
                                                            const taskForThisRamp = tasks.find(task => task.PENDING_LOCATIONID === ramp.LOCATIONID && task.STATUS === 1);
                                                            const taskIndex = tasks.findIndex(task => task.BOOKINGTASKID === taskForThisRamp?.BOOKINGTASKID);

                                                            const isTrailer = pendingBookingMatch?.TRUCKTYPE === 2 && tasks.length > 1;
                                                            const TruckIcon = isTrailer
                                                                ? (taskIndex === 0 ? TruckSVG : TruckCargoSVG)
                                                                : TruckSVG;

                                                            return (
                                                                <div className={`${truckHighlightClass}`}>
                                                                    <span className="descr-for-truck" style={{ transform: "translate(37%, 45%) rotate(90deg)", textAlign: 'center', zIndex: 2 }}>
                                                                        {getTruckDisplayText(pendingBookingMatch)}
                                                                    </span>
                                                                    <TruckIcon />
                                                                </div>
                                                            );
                                                        })()}
                                                        <span className="location-code">
                                                            <div>{ramp.LOCATIONCODE || actualIndex + 1}</div>
                                                        </span>
                                                        {bookingMatch && (
                                                            <div className="truck-svg-wrapper ramp">
                                                                {(() => {
                                                                    const tasks = bookingMatch.BOOKINGTASKS || [];
                                                                    const taskForThisRamp = tasks.find(task => task.LOCATIONID === ramp.LOCATIONID);
                                                                    const taskIndex = tasks.findIndex(task => task.BOOKINGTASKID === taskForThisRamp?.BOOKINGTASKID);

                                                                    if (bookingMatch.TRUCKTYPE === 2 && tasks.length > 1) {
                                                                        return (
                                                                            <>
                                                                                {taskIndex === 0 ? <TruckSVG /> : <TruckCargoSVG />}
                                                                                <div className="descr-for-truck-ramp">
                                                                                    {getTruckDisplayText(bookingMatch)}
                                                                                </div>
                                                                            </>
                                                                        );
                                                                    }
                                                                    return (
                                                                        <>
                                                                            <TruckSVG />
                                                                            <div className="descr-for-truck-ramp">
                                                                                {getTruckDisplayText(bookingMatch)}
                                                                            </div>
                                                                        </>
                                                                    );
                                                                })()}
                                                            </div>
                                                        )}
                                                    </DroppableRamp>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            );
                        })()}
                        <div className="parking-slots-wrapper">
                            <div className="parking-slots-wrapper">
                                {(() => {
                                    const bookedParkingSlots = yardBookings
                                        .flatMap(b => {
                                            const seenLocationIds = new Set();
                                            return (b.BOOKINGTASKS || [])
                                                .filter(task => {
                                                    if (!task.LOCATIONID) return false;
                                                    if (seenLocationIds.has(task.LOCATIONID)) return false;
                                                    seenLocationIds.add(task.LOCATIONID);
                                                    return true;
                                                })
                                                .map(task => {
                                                    const match = yardPositions.find(
                                                        p => p.LOCATIONID === task.LOCATIONID && p.LOCATIONTYPE === 2
                                                    );
                                                    if (!match) return null;

                                                    const booking = b;
                                                    const tasks = booking.BOOKINGTASKS || [];
                                                    const numTasks = tasks.length;

                                                    if (booking.TRUCKTYPE === 2 && numTasks > 1) {
                                                        return Array.from({ length: numTasks }, (_, i) => ({
                                                            ...match,
                                                            booking,
                                                            task: tasks[i],
                                                            slotDuplicateIndex: i
                                                        }));
                                                    }

                                                    return {
                                                        ...match,
                                                        booking,
                                                        task,
                                                        slotDuplicateIndex: 0
                                                    };
                                                })
                                                .flat()
                                        })
                                        .filter(Boolean);


                                    if (bookedParkingSlots.length === 0) {
                                        return (
                                            <div className="no-booking-message" style={{ width: "160px" }}>
                                                <div className="message-content">
                                                    <LocalParkingIcon sx={{
                                                        width: "17%",
                                                        height: "17%",
                                                        color: "rgba(255, 255, 255, 0.8)",
                                                        mb: 1
                                                    }} />
                                                    <span>{t('truckJourney.noParkingMessage', language)}</span>
                                                </div>
                                            </div>
                                        );
                                    }
                                    return [...Array(2)].map((_, rowIndex) => {
                                        const halfIndex = Math.ceil(bookedParkingSlots.length / 2);
                                        const rowItems = rowIndex === 0
                                            ? bookedParkingSlots.slice(0, halfIndex)
                                            : bookedParkingSlots.slice(halfIndex);

                                        return (
                                            <div key={rowIndex} className="parking-row">
                                                {rowItems.map((ramp, index) => {
                                                    const isSecondHalf = rowIndex === 1;
                                                    let className = isSecondHalf ? "parking-slot-half" : "parking-slot";
                                                    if (index === 0) {
                                                        className += isSecondHalf ? " parking-slot-half-start" : " parking-slot-start";
                                                    }
                                                    if (index === rowItems.length - 1) {
                                                        className += isSecondHalf ? " parking-slot-half-end" : " parking-slot-end";
                                                    }
                                                    // const bookingTasks = ramp.booking?.BOOKINGTASKS ?? [];
                                                    const isReadyToLoad = ramp.booking.TRUCKTYPE === 2
                                                        ? (
                                                            ramp.task &&
                                                            typeof ramp.task.STATUS === 'number' &&
                                                            ramp.task.STATUS === 1 &&
                                                            ramp.booking.BOOKING_STATUS === 7
                                                        )
                                                        : (
                                                            ramp.booking.BOOKING_STATUS === 7
                                                        );
                                                    const finished = ramp.booking.BOOKING_STATUS === 7 && (ramp.booking.BOOKINGTASKS || []).every(t => t.STATUS === 3);
                                                    const truckClass = isSecondHalf
                                                        ? "truck-svg-wrapper parking-bottom"
                                                        : "truck-svg-wrapper parking-top"; 
                                                    const truck = ramp.booking.TRUCKTYPE === 2 && ramp.task
                                                        ? { ...ramp.booking, BOOKINGID: ramp.task.BOOKINGTASKID }
                                                        : ramp.booking;
                                                    let count = ramp.slotDuplicateIndex || 0;
                                                    return (
                                                        <div key={ramp.ID || index} className={className}>
                                                            <span className="rotate-text">P{index + 1}</span>
                                                            <div
                                                                className={truckClass}
                                                                onMouseEnter={(e) => {
                                                                    if (finished) return;
                                                                    const rect = e.currentTarget.getBoundingClientRect();
                                                                    setTooltipPosition({
                                                                        x: rect.left + rect.width / 2,
                                                                        y: rect.bottom,
                                                                        isHalfSlot: isSecondHalf
                                                                    });

                                                                    if (ramp.booking.TRUCKTYPE === 2 && ramp.task) {
                                                                        const task = ramp.task;
                                                                        const isPending = typeof task.STATUS === 'number' && task.STATUS >= 1;

                                                                        setSelectedBookingId(ramp.task.BOOKINGTASKID);
                                                                        setSelectedBookingDetails({
                                                                            type: 'task',
                                                                            data: task,
                                                                            isPending,
                                                                            arrivalId: ramp.booking.ARRIVALID
                                                                        });
                                                                    } else {
                                                                        const bookingTasks = ramp.booking?.BOOKINGTASKS || [];
                                                                        const pendingTask = bookingTasks.find(t => typeof t.STATUS === 'number' && t.STATUS >= 1);
                                                                        const queueTasks = bookingTasks.filter(t => t !== pendingTask);
                                                                        const hasPending = bookingTasks.some(t => typeof t.STATUS === 'number' && t.STATUS >= 1);

                                                                        setSelectedBookingId(ramp.booking.BOOKINGID);
                                                                        setSelectedBookingDetails({
                                                                            type: 'booking',
                                                                            data: ramp.booking,
                                                                            bookingTasks,
                                                                            pendingTask,
                                                                            queueTasks,
                                                                            hasPending
                                                                        });
                                                                    }
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    if (!e.relatedTarget ||
                                                                        !e.relatedTarget.closest ||
                                                                        !e.relatedTarget.closest('.toolkit-popup-arrival')) {
                                                                        setSelectedBookingId(null);
                                                                        setSelectedBookingDetails(null);
                                                                    }
                                                                }}
                                                            >
                                                                <DraggableTruck
                                                                    truck={truck}
                                                                    truckClass={truckClass}
                                                                    isReadyToLoad={isReadyToLoad}
                                                                    finished={finished}
                                                                    haveTrailer={ramp.booking.TRUCKTYPE === 2}
                                                                    renderCount={count + 1}
                                                                    isSecondRow={isSecondHalf}
                                                                    isOverRampRow2={isDraggingOverRampRow2}
                                                                    showSupplier={showSupplier}
                                                                />

                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        );
                                    });
                                })()}
                            </div>
                        </div>
                    </div>
                    <RampContextMenu
                        contextMenu={contextMenu}
                        rampTask={rampTask}
                        language={language}
                        yardBookings={yardBookings}
                        yardPositions={yardPositions}
                        onClose={handleCloseContextMenu}
                        onUpdateRamp={handleUpdateRamp}
                        onCancelLoad={handleCancelLoad}
                    />

                </div >
            </DndContext >
        </>
    );
};

export default TruckJourneyLayout;
